// Formulario legacy: ModalContacto / Formulario (sin uso en CTAs; recuperable)
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import CardOpciones from "../CardOpciones";
import ConvertirStringHTML from "../ConvertirStringHTML";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";

import checkIcon from "../../assets/check-square.png";

const VehicleCard = (vehiculo) => {
  const { openConsultaForm } = useWhatsAppConsulta();

  const handleConsultar = (modelo, version, tipo, tipo_financiacion) => {
    window.dataLayer.push({
      modelo: modelo,
      version: version,
      seccion: tipo,
      event: "consultar",
      tipo_financiacion: tipo_financiacion,
    });
    openConsultaForm();
  };

  const tipo = vehiculo.tipo;

  return (
    <div className="h-100 d-block w-100">
      {vehiculo.info.convencional.habilitado && vehiculo.nombreTipo === "convencional" ? (
        <section className="card-new-vehicle h-100 d-flex justify-content-between flex-column">
          <div>
            <div className="card-new-vehicle-header">
              <h2 className="titulo-tarjeta"> {vehiculo.info.convencional.modelo} </h2>
              {vehiculo.info.convencional.version !== "" ? (
                <h3 className="titulo-version-tarjeta"> {vehiculo.info.convencional.version} </h3>
              ) : null}
            </div>
            <div className="card-new-vehicle-imagen">
              <img
                src={vehiculo.info.convencional.main_picture}
                alt={vehiculo.info.convencional.modelo}
                className="img-fluid"
              />
            </div>
            <div className="card-new-vehicle-footer">
              {vehiculo.info.convencional.entrega_inmediata ? (
                <div className="vehicle-footer-entrega-inmediata">
                  <p>
                    {" "}
                    <img src={checkIcon} alt="Icon Check" /> ENTREGA INMEDIATA
                  </p>
                </div>
              ) : null}

              {vehiculo.info.convencional.preventa ? (
                <div className="vehicle-footer-entrega-inmediata">
                  <p>
                    {" "}
                    <img src={checkIcon} alt="Icon Check" /> PREVENTA EXCLUSIVA
                  </p>
                </div>
              ) : null}

              {vehiculo.info.convencional.proximamente ? (
                <div className="vehicle-footer-entrega-inmediata">
                  <p>
                    {" "}
                    <img src={checkIcon} alt="Icon Check" /> PRÓXIMAMENTE
                  </p>
                </div>
              ) : null}

              {vehiculo.info.convencional.descripcion_general.length !== "" ? (
                <div className="vehicle-footer-descripcion-general">
                  <p>{vehiculo.info.convencional.descripcion_general}</p>
                </div>
              ) : null}

              {vehiculo.info.convencional.subtitulo_principal !== "" ? (
                <div className="vehicle-footer-subtitulo-principal">
                  <p>{vehiculo.info.convencional.subtitulo_principal}</p>
                </div>
              ) : null}

              {vehiculo.info.convencional.descripcion_subtitulo_principal !== "" ? (
                <div className="vehicle-footer-descripcion-subtitulo-principal">
                  <p>{vehiculo.info.convencional.descripcion_subtitulo_principal}</p>
                </div>
              ) : null}

              <div className="vehicle-footer-titulo-principal">
                {vehiculo.info.convencional.titulo_principal !== ""
                  ? ConvertirStringHTML(
                      vehiculo.info.convencional.titulo_principal,
                      "vehicle-footer-titulo-principal-a"
                    )
                  : null}

                {vehiculo.info.convencional.descripcion_titulo_principal !== ""
                  ? ConvertirStringHTML(
                      vehiculo.info.convencional.descripcion_titulo_principal,
                      "vehicle-footer-titulo-principal-b"
                    )
                  : null}

                {vehiculo.info.convencional.descripcion_rojo_titulo_principal !== ""
                  ? ConvertirStringHTML(
                      vehiculo.info.convencional.descripcion_rojo_titulo_principal,
                      "vehicle-footer-titulo-principal-c"
                    )
                  : null}
              </div>
            </div>
          </div>

          <div>
            <button
              className="btn-consultar-card"
              id={`${vehiculo.info.convencional.modelo.replace(/\s+/g, "-").toLowerCase()}-${tipo}`}
              onClick={() =>
                handleConsultar(
                  vehiculo.info.convencional.version,
                  vehiculo.info.convencional.modelo,
                  tipo,
                  vehiculo.info.convencional.titulo_principal
                )
              }
            >
              Consultar
            </button>
          </div>
        </section>
      ) : (
        vehiculo.info.plan.habilitado &&
        vehiculo.nombreTipo === "plan" && (
          <section className="card-new-vehicle h-100 d-flex justify-content-between flex-column">
            <div>
              <div className="card-new-vehicle-header">
                <h2 className="titulo-tarjeta"> {vehiculo.info.plan.modelo} </h2>
                {vehiculo.info.plan.version !== "" ? (
                  <h3 className="titulo-version-tarjeta"> {vehiculo.info.plan.version} </h3>
                ) : null}
              </div>
              <div className="card-new-vehicle-imagen">
                <img src={vehiculo.info.plan.main_picture} alt={vehiculo.info.plan.modelo} className="img-fluid" />
              </div>
              <div className="card-new-vehicle-footer">
                {vehiculo.info.plan.entrega_inmediata ? (
                  <div className="vehicle-footer-entrega-inmediata">
                    <p>
                      {" "}
                      <img src={checkIcon} alt="Icon Check" /> ENTREGA INMEDIATA
                    </p>
                  </div>
                ) : null}

                {vehiculo.info.plan.tipos_planes[0].nombre_plan !== "" ? (
                  <div className="vehicle-footer-planes-cuotas">
                    {vehiculo.info.plan.tipos_planes.map((plan, index) => {
                      return (
                        <div key={index} className="vehicle-footer-planes-cuotas-card">
                          <div className="vehicle-footer-planes-cuotas-card-header">
                            <p className="cuotas-card-header-titulo">{plan.nombre_plan}</p>
                            <div className="cuotas-card-header-cuotas-desde">
                              <p className="cuotas-card-header-cuotas-desde-nombre">Cuotas desde:</p>
                              <p className="cuotas-card-header-cuotas-desde-precio">{plan.precio}</p>
                            </div>
                          </div>
                          <div className="vehicle-footer-planes-cuotas-card-footer">
                            <p>{plan.descripcion}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : null}

                {vehiculo.info.plan.descripcion_general.length !== "" ? (
                  <div className="vehicle-footer-descripcion-general">
                    <p>{vehiculo.info.plan.descripcion_general}</p>
                  </div>
                ) : null}

                {vehiculo.info.plan.subtitulo_principal !== "" ? (
                  <div className="vehicle-footer-subtitulo-principal">
                    <p>{vehiculo.info.plan.subtitulo_principal}</p>
                  </div>
                ) : null}

                {vehiculo.info.plan.descripcion_subtitulo_principal !== "" ? (
                  <div className="vehicle-footer-descripcion-subtitulo-principal">
                    <p>{vehiculo.info.plan.descripcion_subtitulo_principal}</p>
                  </div>
                ) : null}

                {/* {vehiculo.info.plan.cuota_desde !== "" ? (
                <div className="vehicle-footer-cuota-desde">
                  <p className="primer-parrafo">Cuotas desde:</p>
                  <p className="segundo-parrafo">{vehiculo.info.plan.cuota_desde}</p>
                </div>
              ) : null} */}

                <div className="vehicle-footer-titulo-principal">
                  {vehiculo.info.plan.titulo_principal !== ""
                    ? ConvertirStringHTML(vehiculo.info.plan.titulo_principal, "vehicle-footer-titulo-principal-a")
                    : null}

                  {vehiculo.info.plan.descripcion_titulo_principal !== ""
                    ? ConvertirStringHTML(
                        vehiculo.info.plan.descripcion_titulo_principal,
                        "vehicle-footer-titulo-principal-b"
                      )
                    : null}

                  {vehiculo.info.plan.descripcion_rojo_titulo_principal !== ""
                    ? ConvertirStringHTML(
                        vehiculo.info.plan.descripcion_rojo_titulo_principal,
                        "vehicle-footer-titulo-principal-c"
                      )
                    : null}
                </div>
              </div>
            </div>
            <div>
              <button
                className="btn-consultar-card"
                id={`${vehiculo.info.plan.modelo.replace(/\s+/g, "-").toLowerCase()}-${tipo}`}
                onClick={() =>
                  handleConsultar(
                    vehiculo.info.plan.version,
                    vehiculo.info.plan.modelo,
                    tipo,
                    vehiculo.info.plan.titulo_principal
                  )
                }
              >
                Consultar
              </button>
            </div>
          </section>
        )
      )}

      {vehiculo.info.preventa.habilitado && vehiculo.nombreTipo === "preventa" && (
        <section className="card-new-vehicle h-100 d-flex justify-content-between flex-column">
          <div>
            <div className="card-new-vehicle-header">
              <h2 className="titulo-tarjeta"> {vehiculo.info.preventa.modelo} </h2>
              {vehiculo.info.preventa.version !== "" ? (
                <h3 className="titulo-version-tarjeta"> {vehiculo.info.preventa.version} </h3>
              ) : null}
            </div>
            <div className="card-new-vehicle-imagen">
              <img
                src={vehiculo.info.preventa.main_picture}
                alt={vehiculo.info.preventa.modelo}
                className="img-fluid"
              />
            </div>
            <div className="card-new-vehicle-footer">
              <div className="vehicle-footer-entrega-inmediata">
                <p>
                  {" "}
                  <img src={checkIcon} alt="Icon Check" /> PREVENTA EXCLUSIVA
                </p>
              </div>

              {vehiculo.info.preventa.descripcion_general.length !== "" ? (
                <div className="vehicle-footer-descripcion-general">
                  <p>{vehiculo.info.preventa.descripcion_general}</p>
                </div>
              ) : null}

              {vehiculo.info.preventa.subtitulo_principal !== "" ? (
                <div className="vehicle-footer-subtitulo-principal">
                  <p>{vehiculo.info.preventa.subtitulo_principal}</p>
                </div>
              ) : null}

              {vehiculo.info.preventa.descripcion_subtitulo_principal !== "" ? (
                <div className="vehicle-footer-descripcion-subtitulo-principal">
                  <p>{vehiculo.info.preventa.descripcion_subtitulo_principal}</p>
                </div>
              ) : null}

              <div className="vehicle-footer-titulo-principal">
                {vehiculo.info.preventa.titulo_principal !== ""
                  ? ConvertirStringHTML(vehiculo.info.preventa.titulo_principal, "vehicle-footer-titulo-principal-a")
                  : null}

                {vehiculo.info.preventa.descripcion_titulo_principal !== ""
                  ? ConvertirStringHTML(
                      vehiculo.info.preventa.descripcion_titulo_principal,
                      "vehicle-footer-titulo-principal-b"
                    )
                  : null}

                {vehiculo.info.preventa.descripcion_rojo_titulo_principal !== ""
                  ? ConvertirStringHTML(
                      vehiculo.info.preventa.descripcion_rojo_titulo_principal,
                      "vehicle-footer-titulo-principal-c"
                    )
                  : null}
              </div>
            </div>
          </div>

          <div>
            <button
              className="btn-consultar-card"
              id={`${vehiculo.info.preventa.modelo.replace(/\s+/g, "-").toLowerCase()}-${tipo}`}
              onClick={() =>
                handleConsultar(
                  vehiculo.info.preventa.version,
                  vehiculo.info.preventa.modelo,
                  tipo,
                  vehiculo.info.preventa.titulo_principal
                )
              }
            >
              Consultar
            </button>
          </div>
        </section>
      )}

      {vehiculo.info?.adjudicado?.habilitado && vehiculo.nombreTipo === "adjudicado" && (
        <section className="card-new-vehicle h-100 d-flex justify-content-between flex-column">
          <div>
            <div className="card-new-vehicle-header">
              <h2 className="titulo-tarjeta"> {vehiculo.info.adjudicado.modelo} </h2>
              {vehiculo.info.adjudicado.version !== "" ? (
                <h3 className="titulo-version-tarjeta"> {vehiculo.info.adjudicado.version} </h3>
              ) : null}
            </div>
            <div className="card-new-vehicle-imagen">
              <img
                src={vehiculo.info.adjudicado.main_picture}
                alt={vehiculo.info.adjudicado.modelo}
                className="img-fluid"
              />
            </div>
            <div className="card-new-vehicle-footer">
              {vehiculo.info.adjudicado.descripcion_general.length !== "" ? (
                <div className="vehicle-footer-descripcion-general">
                  <p>{vehiculo.info.adjudicado.descripcion_general}</p>
                </div>
              ) : null}

              {vehiculo.info.adjudicado.subtitulo_principal !== "" ? (
                <div className="vehicle-footer-subtitulo-principal">
                  <p>{vehiculo.info.adjudicado.subtitulo_principal}</p>
                </div>
              ) : null}

              {vehiculo.info.adjudicado.descripcion_subtitulo_principal !== "" ? (
                <div className="vehicle-footer-descripcion-subtitulo-principal">
                  <p>{vehiculo.info.adjudicado.descripcion_subtitulo_principal}</p>
                </div>
              ) : null}

              <div className="vehicle-footer-titulo-principal">
                {vehiculo.info.adjudicado.titulo_principal !== ""
                  ? ConvertirStringHTML(vehiculo.info.adjudicado.titulo_principal, "vehicle-footer-titulo-principal-a")
                  : null}

                {vehiculo.info.adjudicado.descripcion_titulo_principal !== ""
                  ? ConvertirStringHTML(
                      vehiculo.info.adjudicado.descripcion_titulo_principal,
                      "vehicle-footer-titulo-principal-b"
                    )
                  : null}

                {vehiculo.info.adjudicado.descripcion_rojo_titulo_principal !== ""
                  ? ConvertirStringHTML(
                      vehiculo.info.adjudicado.descripcion_rojo_titulo_principal,
                      "vehicle-footer-titulo-principal-c"
                    )
                  : null}
              </div>
            </div>
          </div>

          <div>
            <button
              className="btn-consultar-card"
              id={`${vehiculo.info.adjudicado.modelo.replace(/\s+/g, "-").toLowerCase()}-${tipo}`}
              onClick={() =>
                handleConsultar(
                  vehiculo.info.adjudicado.version,
                  vehiculo.info.adjudicado.modelo,
                  tipo,
                  vehiculo.info.adjudicado.titulo_principal
                )
              }
            >
              Consultar
            </button>
          </div>
        </section>
      )}
    </div>
  );
};

export default VehicleCard;
